import API from '@/api/index';
import moment from 'moment';
import * as Auth from '../../utils/auth';

const crm = {
  state: {
    cases: [],
    newCases: [],
    supporters: [],
    selectedCase: null,
    directionByAirLines: true,
    accountCRM: null
  },

  mutations: {
    CLEAR_DATA: state => {
      state.cases = [];
      state.newCases = [];
      state.supporters = [];
    },
    APPEND_CASES: (state, cases) => {
      state.cases = cases;
      state.newCases = cases.filter(
        a => !a.RepairPerson && a.Status !== 'Closed'
      );
    },
    UPDATE_REPAIR_PERSON: (state, c) => {
      let caseToUpdate = state.cases.filter(a => a.Id === c.Id)[0];
      state.newCases.map(a => {
        if (a.Id === caseToUpdate.Id) {
          a.RepairPerson = c.RepairPerson;
          a.Plan = c.Plan;
        }
        return 0;
      });
      state.cases.map(a => {
        if (a.Id === caseToUpdate.Id) {
          a.RepairPerson = c.RepairPerson;
          a.Plan = c.Plan;
        }
        return 0;
      });

      let list = [];
      state.supporters.map(s => {
        let item = s;
        item['Cases'] = [];
        state.cases.map(c => {
          if (c.RepairPerson === s.Name) {
            item.Cases.push(c);
            item.Cases.sort((a, b) => {
              let timeA = moment(a.Plan);
              let timeB = moment(b.Plan);
              return timeA - timeB;
            });
          }
          return 0;
        });
        list.push(item);
        return 0;
      });
      state.supporters = list;
    },
    APPEND_SUPPORTERS: (state, supporters) => {
      state.supporters = supporters;
    },
    SET_CASE_TO_SUPPORTERS: state => {
      let list = [];

      state.supporters.map(s => {
        let item = s;
        item['Cases'] = [];

        state.cases.map(c => {
          if (c.RepairPerson === s.Id) {
            item.Cases.push(c);
            item.Cases.sort((a, b) => {
              let timeA = moment(a.Plan);
              let timeB = moment(b.Plan);
              return timeA - timeB;
            });
          }

          if (c.RepairPersonList && c.RepairPersonList.includes(s.Username)) {
            if (c.RepairPerson !== s.Name) {
              item.Cases.push(c);
              item.Cases.sort((a, b) => {
                let timeA = moment(a.Plan);
                let timeB = moment(b.Plan);
                return timeA - timeB;
              });
            }
          }

          return 0;
        });
        list.push(item);
        return 0;
      });
      state.supporters = list;
      state.loadingWaypoint = true;
    },
    SET_WAYPOINT_TO_SUPPORTERS: (state, waypoints) => {
      waypoints.map(wp => {
        state.supporters.map(s => {
          if (Number(s.VehicleId) === Number(wp.Id)) s['Waypoint'] = wp;
          return 0;
        });
        return 0;
      });
    },
    SET_SELECTED_CASES: (state, c) => {
      state.selectedCase = c;
    },
    SET_DIRECTION_BY_AIR_LINES: (state, c) => {
      state.directionByAirLines = c;
    },
    SET_ACCOUNT_CRM: (state, c) => {
      state.accountCRM = c;
    }
  },

  actions: {
    AccountRequest ({ commit }, trackingId) {
      return new Promise((resolve, reject) => {
        API.crm
          .AccountRequest(trackingId)
          .then(response => {
            if (response.data.Data) {
              commit('SET_ACCOUNT_CRM', response.data.Data);
              resolve(response.data.Data);
            } else {
              reject(response.data.Code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    ContacsRequest ({ commit }, accountId) {
      return new Promise((resolve, reject) => {
        API.crm
          .ContacsRequest(accountId)
          .then(response => {
            if (response.data.Data) {
              resolve(response.data.Data);
            } else {
              reject(response.data.Code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    CasesRequest ({ commit }, accountId) {
      return new Promise((resolve, reject) => {
        API.crm
          .CasesRequest(accountId)
          .then(response => {
            if (response.data.Data) {
              resolve(response.data.Data);
            } else {
              reject(response.data.Code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    GetSupporters ({ state, commit, dispatch }, params) {
      return new Promise((resolve, reject) => {
        API.crm
          .GetSupporters(params)
          .then(response => {
            if (response.data.Data.length > 0) {
              commit('APPEND_SUPPORTERS', response.data.Data);
              resolve(response.data.Data);
            } else {
              reject(response.data.Code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    GetAllCases ({ commit }) {
      return new Promise((resolve, reject) => {
        API.crm
          .GetAllCases()
          .then(response => {
            if (response.data.Data) {
              commit('APPEND_CASES', response.data.Data);
              resolve(response.data.Data);
            } else {
              reject(response.data.Code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    GetProfile ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.crm
          .GetProfile(data.Email)
          .then(response => {
            let logUser = data;
            if (response.data.Data) {
              logUser.Extension = response.data.Data.Extension;
              Auth.setLoggedUser(logUser);
              resolve(response.data.Data);
            } else {
              reject(response.data.Code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    CaseDispatch ({ commit }, data) {
      return new Promise((resolve, reject) => {
        console.log(data);
        API.crm
          .CaseDispatch(data)
          .then(response => {
            if (response.data.Data) {
              resolve(response.data.Data);
            } else {
              reject(response.data.Code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    UpdatePlan ({ commit }, data) {
      return new Promise((resolve, reject) => {
        console.log(data);
        API.crm
          .UpdatePlan(data)
          .then(response => {
            if (response.data.Data) {
              resolve(response.data.Data);
            } else {
              reject(response.data.Code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default crm;



// WEBPACK FOOTER //
// ./src/store/modules/crm.js